import React from 'react';
import {isAndroid, isIOS, isMobile} from "react-device-detect";

class IsMobile extends React.Component {
    componentDidMount() {
        if (isMobile) {
            if(isIOS) {
                window.location.href = "https://apps.apple.com/us/app/lalert/id1596761949";
            }

            if(isAndroid) {
                window.location.href = "https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.lalert.global";
            }
        } else {
            alert("View Download Link From Mobile Phone");
        }
    }

    render() {
        return (
            <div>
                <div>
                    <p className={"userAdminsEmptyWarning"}>Download the Lalert mobile app</p>
                </div>
            </div>
        );
    }
}

export default IsMobile;